import React, { Component } from 'react';
import SeatContainer from '../seat/seatContainer';
import imgUser from "../../img/no-profile.png";

class InfoCommon extends Component {

  
    render() {
                    var date = new Date();
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);
            var test_name =" ";
            const today= year + "-" + month + "-" + day;
            const token = JSON.parse(localStorage.getItem("userInfo"));


        console.log("InfoCommon:"+this.props.test_sec);
        return (
            <>
                <tr>
                    <th rowSpan="4"><div className="img-box d-flex justify-content-center align-items-center"><img src={imgUser} alt="" ></img></div></th>
                    <th className="title">시험명</th>
                    <td>{(typeof token !==null )?token[0].test_name:" " }</td>
                </tr>
                <tr>
                    <th className="title">시험일</th>
                    <td>{today}</td>
                </tr>
                <tr>
                    <th className="title">교시</th>
                    <td>{token[0].test_sec}</td>
                </tr>
                <tr>
                    <th className="title">응시번호</th>
                    <td>{this.props.mb_id}</td>
                </tr>
                <tr>
                    <th rowSpan={this.props.rowSanpNum}>
                        <SeatContainer Sitnum={this.props.Sitnum} />
                    </th>
                    <th className="title">성명</th>
                    <td>{this.props.mb_name}</td>
                </tr>
            </>
        );
    }
}

export default InfoCommon;